export const initMenu = (menuButton: string): void => {
  const button = document.querySelector<HTMLElement>(menuButton);

  if (button) {
    button.addEventListener("click", () => button.classList.toggle("open"));
  }
};
